import React from "react";
import { Box } from "@mui/material";

export default function ProtectedImage({
  src,
  alt = "",
  ratio, // e.g., 5/1 or "5 / 1"
  fit = "contain",
  position = "left bottom",
  clickable = false,
  sx = {},
  ...rest
}) {
  // Normalize ratio into a CSS-friendly value
  const aspectRatio =
    typeof ratio === "number"
      ? `${ratio}`
      : typeof ratio === "string"
      ? ratio
      : undefined;

  return (
    <Box
      role="img"
      aria-label={alt}
      onContextMenu={(e) => e.preventDefault()}
      onMouseDown={(e) => e.button === 2 && e.preventDefault()}
      onDragStart={(e) => e.preventDefault()}
      sx={{
        // core background rendering
        backgroundImage: `url(${src})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: fit,
        backgroundPosition: position,

        // sizing behavior
        display: "block",
        width: "100%", // allows width-driven sizing
        height: "auto",

        // if a ratio is provided, use modern CSS aspect-ratio
        ...(aspectRatio ? { aspectRatio } : {}),

        // protection
        userSelect: "none",
        WebkitUserDrag: "none",
        pointerEvents: clickable ? "auto" : "none",

        ...sx,
      }}
      {...rest}
    />
  );
}
